import { Box, Stack, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { useLabelFormContext } from '../LabelFormContext'
import { LabelName } from './LabelName'

type Props = {
  children: ReactNode
}

/**
 * ラベルの名前と画像の編集
 * 通常時はラベル画像と画像上の検査箇所を描画し、
 * 検査箇所を編集中はインタラクティブ(bboxを操作）なラベル画像を表示するため、childrenで外から渡す
 */
export const LabelSection: FC<Props> = ({ children }) => {
  const { control, nameHistories } = useLabelFormContext()

  return (
    <Stack
      spacing={4}
      p={2}
      overflow={{ xs: 'hidden', md: 'auto' }}
      height={{ md: 'calc(100vh - 64px)' }}
    >
      <Box maxWidth="520px">
        <LabelName control={control} options={nameHistories} />
      </Box>
      <Stack spacing={2}>
        <Stack spacing={1} maxWidth="800px">
          <Typography
            sx={{ color: 'text.primary', fontWeight: 'bold', fontSize: 14 }}
            component="h2"
          >
            見本ラベル
          </Typography>
          <Typography variant="caption" color="text.secondary">
            画像の中で2点をクリックして四角形を作り、検査範囲を設定してください。
          </Typography>
          {children}
        </Stack>
      </Stack>
    </Stack>
  )
}
